'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * These are colors which are not currently captured by Narvar's theme structure.
 */
const colors = {
  statusWarn: '#F18C0F',
  statusWarnLight: '#FDEEDB',
  statusWarnDark: '#9A5909',
  statusIndeterminate: '#9E9E9E',
  statusIndeterminateLight: '#E0E0E0',
  statusIndeterminateDark: '#424242',
  statusDanger: '#E53935',
  statusDangerLight: '#FFD4CA',
  statusDangerDark: '#A71916',
  statusSuccess: '#09C98F',
  statusSuccessLight: '#ABEDD9',
  statusSuccessDark: '#176839',
  statusInfo: '#0096D4',
  statusInfoLight: '#D8EEF8',
  statusInfoDark: '#0C5E83',
  white: '#FFFFFF'
};

exports.colors = colors;
